import React, { useState } from "react";
import { Box, Button, TextField } from "@mui/material";
import useSWR from "swr";
const QnaAnswer = (params) => {
  const { data, error } = useSWR(
    process.env.REACT_APP_DEF_URL + "qnaswer?qna_id=" + params.Id
  );
  const [QText, setQText] = useState();
  if (error) return <div>failed to load</div>;
  if (!data) return <div>loading...</div>;
  return (
    <>
      {params.verify === 1 ? (
        <Box
          sx={{
            "& > :not(style)": {
              m: 1,
              width: "80%",
              display: "flex",
              alignItems: "center",
            },
          }}
          component="form"
          method="post"
          action={process.env.REACT_APP_DEF_URL + "qnaupdate.php"}
        >
          <input name="qna_id" value={data.qna_id} type="hidden" />
          <input name="question_id" value={data.question_id} type="hidden" />
          <TextField
            id="outlined-basic"
            label="Cevap"
            variant={"outlined"}
            name="question_text"
            onChange={(e) => setQText(e.target.value)}
            value={QText}
            fullWidth
            multiline
            defaultValue={data.question_text}
          />
          <Button variant="outlined" type="submit">
            Gönder
          </Button>
        </Box>
      ) : (
        <Box
          sx={{
            "& > :not(style)": {
              m: 1,
              width: "80%",
              display: "flex",
              alignItems: "center",
            },
          }}
          component="form"
          method="post"
          action={process.env.REACT_APP_DEF_URL + "qnadd.php"}
        >
          <input name="qna_id" value={params.Id} type="hidden" />
          <TextField
            id="outlined-basic"
            label="Cevap"
            variant={"outlined"}
            name="question_text"
            onChange={(e) => setQText(e.target.value)}
            value={QText}
            fullWidth
            multiline
            defaultValue={data.question_text}
          />
          <Button variant="outlined" type="submit">
            Gönder
          </Button>
        </Box>
      )}
    </>
  );
};

export default QnaAnswer;
